import './App.css';

// ----- MODE MAINTENANCE -----
// Passer à false pour désactiver la page de maintenance et rétablir l'accès normal.
const MAINTENANCE_MODE = true;
// -----------------------------

function App() {
  if (MAINTENANCE_MODE) {
    return (
      <div className="maintenance-page">
        <div className="maintenance-content">
          <div className="maintenance-icon"><i className="bi bi-tools"></i></div>
          <h1 className="maintenance-title">Maintenance en cours</h1>
          <p className="maintenance-message">
            Notre plateforme de demande d'équivalence est actuellement en cours de maintenance .
          </p>
          <p className="maintenance-reassurance">
            Nous mettons tout en œuvre pour rétablir l'accès dans les plus brefs délais.
            Nous vous invitons à revenir ultérieurement.
          </p>
          <p className="maintenance-thanks">
            Merci de votre compréhension et de votre patience.
          </p>
        </div>
      </div>
    );
  }

  // -- Code normal de l'application (désactivé en maintenance) --
  return <AppContent />;
}

// Composant séparé pour éviter de charger les imports inutilement en maintenance
function AppContent() {
  const { useState, useEffect } = require('react');
  const ConditionsPage = require('./pages/ConditionsPage').default;
  const FormulairePage = require('./pages/FormulairePage').default;
  const StatusPage = require('./pages/StatusPage').default;

  const [showSplash, setShowSplash] = useState(true);
  const [currentPage, setCurrentPage] = useState('conditions');

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return (
      <div className="splash-screen">
        <div className="splash-content">
          <img src="/app-logo.png" alt="app logo" className="splash-logo" />
          <p className="splash-text">DEMANDE D'EQUIVALENCE</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {currentPage === 'conditions' && (
        <ConditionsPage onContinue={() => setCurrentPage('formulaire')} onShowDemand={() => setCurrentPage('status')} />
      )}
      {currentPage === 'formulaire' && (
        <FormulairePage onBack={() => setCurrentPage('conditions')} onShowDemand={() => setCurrentPage('status')} />
      )}
      {currentPage === 'status' && (
        <StatusPage onBack={() => setCurrentPage('conditions')} />
      )}
    </div>
  );
}

export default App;
